export const concurrentWorkConfirmationReason = "concurrent_work_confirmation_required";
export const concurrentWorkConfirmationEvent = "app:confirm-concurrent-work";

export const request_concurrent_work_confirmation = () => new Promise(resolve => {
  const detail = { resolve, handled: false };
  window.dispatchEvent(new CustomEvent(concurrentWorkConfirmationEvent, { detail }));
  if (!detail.handled) resolve("");
});

export const run_with_concurrent_work_confirmation = async request => {
  let response;
  try {
    response = await request("");
    if (response?.data?.reason !== concurrentWorkConfirmationReason) return response;
  } catch (error) {
    if (error?.response?.data?.reason !== concurrentWorkConfirmationReason) throw error;
  }

  const confirmation = await request_concurrent_work_confirmation();
  if (!confirmation) {
    const error = new Error("Work start cancelled.");
    error.cancelled = true;
    throw error;
  }

  return request(confirmation);
};
